import { Flex, Typography, Spin } from "antd";
import { lazy, Suspense, memo } from "react";

import Breadcrumbs from "@/components/ui/Breadcrumbs";

// Лениво загружаемые секции для уменьшения initial bundle
// Примечание: при необходимости можно подсказать webpack имя чанка через комментарий
// lazy(() => import(/* webpackChunkName: "settings-analytic-reports" */ "./components/AnalyticReports"))
const AnalyticReports = lazy(() => import("./components/AnalyticReports"));
// lazy(() => import(/* webpackChunkName: "settings-requests" */ "./components/Requests"))
// const Requests = lazy(() => import("./components/Requests"));
const RequestsForms = lazy(() => import("./components/RequestsForms"));
const Reports = lazy(() => import("./components/Reports"));

// Выносим статичные данные за пределы компонента, чтобы не пересоздавались на каждый рендер
const BREADCRUMB_ITEMS = [
  { title: "Административная панель" },
  { title: "Настройки системы" },
];

/**
 * Страница «Настройки системы» в административной панели.
 */
const SystemSettings = memo(() => (
  <Flex vertical gap={10}>
    <Breadcrumbs items={BREADCRUMB_ITEMS} />
    <Flex vertical gap={30}>
      <Typography.Title level={2} className="no-margin">
        Настройки системы
      </Typography.Title>
      {/* Suspense ожидает загрузку обоих ленивых компонентов ниже и показывает спиннер.
          Если нужно, чтобы секции появлялись независимо, оберните каждую в свой Suspense. */}
      <Suspense
        fallback={
          <Flex justify="center" align="center" style={{ minHeight: 120 }}>
            <Spin />
          </Flex>
        }
      >
        {/* Блок аналитических отчётов (лениво подгружается) */}
        <AnalyticReports />
        {/* Блок заявок (лениво подгружается)
        <Requests /> */}
        {/* Блок заявок (лениво подгружается) */}
        <RequestsForms />
        {/* Блок отчетов (лениво подгружается) */}
        <Reports />
      </Suspense>
    </Flex>
  </Flex>
));

export default SystemSettings;
